import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FormData } from '../CareersApplicationForm';

interface PersonalInfoStepProps {
  formData: FormData;
  updateFormData: (data: Partial<FormData>) => void;
}

const PersonalInfoStep: React.FC<PersonalInfoStepProps> = ({ formData, updateFormData }) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold mb-4">Personal Information</h3>
        <p className="text-sm text-gray-600 mb-6">Tell us about yourself and the position you're interested in.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="firstName">First Name *</Label>
          <Input
            id="firstName"
            value={formData.firstName}
            onChange={(e) => updateFormData({ firstName: e.target.value })}
            placeholder="Enter your first name"
          />
        </div>
        <div>
          <Label htmlFor="lastName">Last Name *</Label>
          <Input
            id="lastName"
            value={formData.lastName}
            onChange={(e) => updateFormData({ lastName: e.target.value })}
            placeholder="Enter your last name"
          />
        </div>
      </div>

      <div>
        <Label htmlFor="email">Email Address *</Label>
        <Input
          id="email"
          type="email"
          value={formData.email}
          onChange={(e) => updateFormData({ email: e.target.value })}
          placeholder="your.email@company.com"
        />
      </div>

      <div>
        <Label htmlFor="phone">Phone Number</Label>
        <Input
          id="phone"
          value={formData.phone}
          onChange={(e) => updateFormData({ phone: e.target.value })}
          placeholder="+1 (555) 123-4567"
        />
      </div>

      <div>
        <Label htmlFor="location">Location *</Label>
        <Input
          id="location"
          value={formData.location}
          onChange={(e) => updateFormData({ location: e.target.value })}
          placeholder="City, State/Country"
        />
      </div>

      <div>
        <Label htmlFor="positionType">Position Type *</Label>
        <Select value={formData.positionType} onValueChange={(value) => updateFormData({ positionType: value })}>
          <SelectTrigger>
            <SelectValue placeholder="Select the position you're applying for" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="frontend-developer">Frontend Developer</SelectItem>
            <SelectItem value="backend-developer">Backend Developer</SelectItem>
            <SelectItem value="fullstack-developer">Full Stack Developer</SelectItem>
            <SelectItem value="data-engineer">Data Engineer</SelectItem>
            <SelectItem value="devops-engineer">DevOps Engineer</SelectItem>
            <SelectItem value="ai-engineer">AI/ML Engineer</SelectItem>
            <SelectItem value="product-manager">Product Manager</SelectItem>
            <SelectItem value="ui-ux-designer">UI/UX Designer</SelectItem>
            <SelectItem value="business-analyst">Business Analyst</SelectItem>
            <SelectItem value="sales-representative">Sales Representative</SelectItem>
            <SelectItem value="marketing-specialist">Marketing Specialist</SelectItem>
            <SelectItem value="customer-success">Customer Success Manager</SelectItem>
            <SelectItem value="operations">Operations Specialist</SelectItem>
            <SelectItem value="other">Other</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default PersonalInfoStep;